var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2539 1.50244C12.9107 1.50244 14.2539 2.84559 14.2539 4.50244C14.2539 5.04921 14.1076 5.56182 13.8521 6.00327L17.2539 6.00244V7.50242H15.7539V15.0024C15.7539 15.4166 15.4181 15.7524 15.0039 15.7524H3.00391C2.5897 15.7524 2.25391 15.4166 2.25391 15.0024V7.50242H0.753906V6.00244L4.15573 6.00327C3.90019 5.56182 3.75391 5.04921 3.75391 4.50244C3.75391 2.84559 5.09705 1.50244 6.75391 1.50244C7.65032 1.50244 8.45492 1.8956 9.0046 2.51889C9.55292 1.8956 10.3575 1.50244 11.2539 1.50244ZM8.25392 7.50242H3.75391V14.2524H8.25392V7.50242ZM14.2539 7.50242H9.75392V14.2524H14.2539V7.50242ZM6.75391 3.00244C5.92548 3.00244 5.25391 3.67401 5.25391 4.50244C5.25391 5.29321 5.86582 5.94106 6.64196 5.99832L6.75391 6.00244H8.25392V4.50244C8.25392 3.75121 7.7017 3.12896 6.98099 3.01952L6.86586 3.00656L6.75391 3.00244ZM11.2539 3.00244C10.4631 3.00244 9.81527 3.61435 9.75805 4.3905L9.75392 4.50244V6.00244H11.2539C12.0446 6.00244 12.6925 5.39053 12.7498 4.61439L12.7539 4.50244C12.7539 3.67401 12.0824 3.00244 11.2539 3.00244Z",
    fill: "#5E6164"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.dee1e4b098ea676f4f7ed22282d216ed.svg";
export { ForwardRef as ReactComponent };